<template>
  <PageMain
    ref="main"
    :loading="loading"
    :tableData="tableData"
    @reload="getData()"
  />
</template>
<script>
import PageMain from './main'
export default {
  components: { PageMain },
  props: { custCode: { type: String, default: '' } },
  data() {
    return {
      tableData: [],
      loading: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      const res = await this.$api
        .masterCustomerDepListApi({ custCode: this.custCode })
        .catch(() => null)
      this.loading = false
      this.tableData = res?.body?.data || []
    },
  },
}
</script>
